import { TranslationsWebsite } from '@/generated/data.schemas';

const translations: TranslationsWebsite = {
	email: {},
	mobileMenu: {
		showAllIn: 'Show all in',
		showAll: 'Show all',
		showCategoriesIn: 'Show categories in',
		goToPage: 'See all',
		menuHeadingPrefix: 'CJC',
	},
	footer: {
		copyright: 'Copyright © 2024 CC Jensen',
	},
	author: {
		linkedIn: 'LinkedIn',
		contact: 'Contact',
		linkedInAriaLabel: 'LinkedIn profile for {0}',
		contactAriaLabel: 'Contact {0}',
	},
	knowledgeHub: {
		noArticles: 'No articles are currently available in this category.',
		allArticles: 'All articles',
		filterByCategory: 'Filter articles by category',
		relatedTags: 'Related tags:',
		readArticle: 'Read article',
		readArticleAriaLabel: 'Read {0}',
	},
	miniBasket: {
		productsInCart: 'products in cart',
		goToBasket: 'Continue to cart',
	},
	customerSelector: {
		searchPlaceholder: 'Search for customer',
		changeCustomer: 'Change customer',
		chooseCustomer: 'Choose customer',
		customerNotValid: 'Customer not valid',
	},
	shared: {
		noPrice: 'No price available',
		priceError: 'Error loading price',
		loading: 'Loading...',
		account: 'Account',
		delete: 'delete',
		siteName: 'CC Jensen',
		skipToMainContent: 'Skip to main content',
		trueString: 'True',
		falseString: 'False',
		reset: 'Reset',
		close: 'Close',
		back: 'Back',
		backTo: 'Back to',
		save: 'Save',
		cancel: 'Cancel',
		previous: 'Previous',
		next: 'Next',
		nextConfiguration: 'Next configuration',
		slide: 'Slide',
		becomes: 'Becomes',
		menuLabel: 'Menu',
		searchPlaceholder: 'Search...',
		searchIconLabel: 'Search',
		searchInputLabel: 'Search the products',
		searchSubmit: 'Submit',
		miniBasketTitle: 'Basket',
		onSale: 'On sale',
		frontpage: 'Frontpage',
		showMore: 'Show more',
		showLess: 'Show mindre',
		genericErrorMsg: 'Something went wrong. Try again soon.',
		unsupportedVideo:
			"Sorry, your browser doesn't support embedded videos, but don't worry," +
			'you can download the video and watch it with your preferred video player!',
		noProductsFound: 'No products found',
		yesContinueBtn: 'Yes, continue',
		itemNo: 'Item no:',
		readMore: 'Read more',
		moreInformationAbout: 'More information about',
		navigation: {
			primary: 'Primary',
			secondary: 'Secondary',
			nav: 'navigation',
			product: 'Product',
			footer: 'Footer',
			user: 'User',
			category: 'Category',
			top: 'Top',
			breadcrumbs: 'Breadcrumbs',
			slider: 'Slider',
			corporateLink: 'Go to corporate site',
			segmentBarTitle: 'Selection by Customer Application',
		},
		quicksearch: {
			close: 'Close',
			showAll: 'Show all',
			suggestions: 'Suggestions',
			products: 'Products',
			articles: 'Articles',
		},
		pagination: {
			youHaveViewed: "You've viewed",
			of: 'of',
			page: 'page',
			products: 'products',
			showNext: 'Show more products',
			showPrevious: 'Show previous products',
			nextPage: 'Next Page',
			previousPage: 'Previous Page',
			showNextArticles: 'Show more articles',
			showPreviousArticles: 'Show previous articles',
			articles: 'articles',
		},
		customerInfo: {
			name: 'First and last name',
			email: 'E-mail',
			password: 'Password',
			repeatPassword: 'Repeat password',
			oldPassword: 'Old password',
			newPassword: 'New password',
			phone: 'Phone number',
			address1: 'Address line 1',
			address2: 'Address line 2',
			zipcode: 'ZIP code',
			city: 'City',
			country: 'Country',
		},
		edit: 'edit',
		noResult: 'noResult',
		filters: {
			resetFilters: 'Reset Filters',
			showSelected: 'Show',
			allFilters: 'All Filters',
		},
		continue: 'Yes, continue',
		nextAdditionals: 'Next additionals',
		articleNo: '',
		segmentations: {},
		customer: '',
	},
	account: {
		welcome: 'Welcome,',
		profile: {
			heading: 'Profile',
			submit: 'Save',
			nameIsRequired: 'Name is required',
			deleteProfileTitle: 'Delete profile',
			deleteProfileText: 'Are you sure you want to delete your profile?',
			supportMail: 'support@ccjensen.com',
		},
		settings: {
			heading: 'Settings',
			changePassword: 'Change password',
			submit: 'Change',
		},
	},
	auth: {
		impersonating: 'You are logged in as: {0}',
		backToSignIn: 'Back to login',
		signin: {
			heading: 'Log in',
			forgotPassword: 'Forgot password?',
			rememberMe: 'Remember me',
			login: 'Log in',
			logout: 'Log out',
			newCustomer: 'New customer?',
			register: 'Create account',
			unknownUserOrInvalidPassword: 'Unknown user or invalid password',
			azureAdLogin: 'Azure AD',
			teaser: 'Welcome',
		},
		forgotPassword: {
			heading: 'Forgot password?',
			text:
				'Enter the e-mail address you used when creating your account. Then we will send a link where you can ' +
				'reset your password if you have an account.',
			submit: 'Send',
			success: 'An e-mail has been sent',
		},
		changePassword: {
			failed: 'Your password could not be changed',
			passwordsAreNotTheSame: 'Passwords are not the same',
			confirmPasswordIsRequired: 'Confirm password is required',
			newPasswordIsRequired: 'New password is required',
			newPasswordMaxLength: 'New password must be max 100 characters',
			newPasswordMinLength: 'New password must be min 6 characters',
			oldPasswordIsRequired: 'Old password is required',
		},
		register: {
			heading: 'Create account',
			submit: 'Create account',
			success: 'Your account has been created',
			confirmPasswordIsRequired: 'Confirm password is required',
			emailIsNotValid: 'E-mail is not valid',
			emailIsRequired: 'E-mail is required',
			passwordIsRequired: 'Password is required',
			passwordMaxLength: 'Password must be max 100 characters',
			passwordMinLength: 'Password must be min 6 characters',
			passwordsAreNotTheSame: 'Passwords are not the same',
			termsText: 'By creating an account, you agree to our {0}',
			terms: 'Terms of use',
		},
		resetPassword: {
			heading: 'Change password',
			submit: 'Change password',
			success: 'Your password has been changed',
		},
		setPassword: {
			heading: 'Set password',
			submit: 'Set password',
			success: 'Your password has been set',
			failed: 'Your password could not be set',
		},
		confirmEmail: {
			heading: 'Confirm e-mail',
			success: 'Your e-mail has been confirmed',
			failed: 'Your e-mail could not be confirmed',
		},
	},
	pageTitles: {
		articleList: 'Search results:',
		basket: 'Basket',
		login: 'Log in',
		forgottenPassword: 'Forgotten password',
		resetPassword: 'Reset password',
		register: 'Sign up',
		confirmEmail: 'Confirm e-mail',
		profile: 'Profile',
		settings: 'Settings',
	},
	productList: {
		productListTitle: 'Product list',
		showing: 'Showing',
		products: 'products',
		searchInResults: 'Search in results',
		searchIn: 'Search in',
		searchInResultsPlaceholder: 'Search by name, attribute etc.',
		showAll: 'Show all',
		showLess: 'Show færre',
		showPagination: 'Show pagination',
		resultsFor: 'You have searched for "{0}"',
		noResultsFor: 'No results for "{0}"',
		resultsFound: 'We have found {0} results',
		didYouMean: 'Did you mean {0}',
		showMoreProductsButtonShow: 'Show',
		showMoreProductsButtonMore: 'flere',
		refineSelection: 'Refine selection',
		noProductsSelected: 'No products selected',
		showAllSizes: 'Show all sizes',
		searchSuggestionsHeadline: 'Search suggestions',
		searchSuggestionsText1: 'Check if you have spelled correct',
		searchSuggestionsText2: 'Try to use more generel words',
		searchSuggestionsText3: 'Try other words with same meaning',
		fromText: 'From',
		borderStyleFilterTranslation: 'Lorem ipsum dolor sit amet and a filter',
		sortBy: 'Sort By',
		view: 'View',
		availability: {
			unknown: 'Sold',
			available: 'In stock',
			onlyFew: 'Few remaining',
			soldOut: 'Sold out',
			inStoreOnly: 'Only in store',
			externalWarehouse: 'Remote warehouse',
			soldOutOnWeb: 'Only in store',
		},
		sorting: {
			sortingStr: 'Sorting',
			relevance: 'Relevance',
			priceAscending: 'Price - ascending',
			priceDescending: 'Price - descending',
			nameAscending: 'Alphabetically',
			nameDescending: 'Alphabetically - reversed',
		},
		filters: {
			filtersButton: 'Filters',
			price: 'Price',
			productGroup: 'Category',
			brand: 'Brand',
			min: 'Min',
			max: 'Max',
			campaign: 'Campaigns',
			inCampaign: 'Campaign',
			outlet: 'Outlet',
			choose: 'Choose',
			seeAll: 'See all',
			resetFilters: 'Reset filters',
			showProductsBtnString1: 'Show',
			showProductsBtnString2: 'products',
			subPages: 'Subpages',
			stockFilter: 'Only show products on stock',
		},
		selector: {
			title: '',
			description: '',
			button: '',
		},
		pageMetaData: {
			title: 'Search Result:',
			description: 'Search Result:',
			keywords: 'search result',
		},
	},
	productDetails: {
		mandatoryAddOns: 'Mandatory add-ons',
		productDescription: 'Product description',
		specifications: 'Specifications',
		documents: 'Documents',
		relatedProducts: 'Related products',
		addToBasket: 'Add to basket',
		siblingsTitle: 'Color',
		variantsTitle: 'Size',
		clearSelection: 'Clear Selection',
		addedToBasket: 'Product added to cart',
		addOn: '',
		inserts: '',
		price: '',
		sparePartsProducts: '',
		insertsProducts: '',
		accessoryProducts: '',
	},
	basket: {
		title: 'Your basket',
		customerDiscount: 'Discount',
		basketEmpty: 'Your basket is empty',
		basketEmptyMessage: 'The basket is empty',
		continueShoppingButton: 'Continue shopping',
		checkoutButton: 'Go to checkout',
		addOneItem: 'Add one item',
		removeOneItem: 'Remove one item',
		mandatory: 'This item is mandatory',
		removeLine: 'Remove item',
		quantityTitle: 'Quantity',
		emptyBasketHeading: 'Your basket is empty',
		emptyBasketText: 'Before proceeding to checkout you must add some products to it.',
		createOffer: '',
		saveAsDraft: '',
		customerRef: '',
		removeOffer: '',
		additionalProducts: '',
		removeOfferSuccess: '',
		removeOfferFailed: '',
		basketName: '',
		saveBasketName: '',
		editBasketName: '',
		createNewOffer: '',
		saveOffer: '',
		companionProductNotAllowedAsAdditionalLine: '',
		companionAdditionalLineCannotBeCompanion: '',
		companionVariantIdRequired: '',
		invalidCompanionProduct: '',
		deleteBasketProducts: {
			headline: '',
			teaser: '',
		},
		overwriteOffer: {
			headline: '',
			teaser: '',
		},
		basketNotificationModal: {
			title: 'Please note:',
		},
		pageMetaData: {
			title: 'Basket',
			description: 'Basket',
			keywords: 'basket',
		},
		amount: '',
		price: '',
		total: '',
		salesRepDiscount: 'Quotation Discount',
		salesRepDiscountLabel: 'Add additional quotation discount',
		quantityIncrement: '',
		goToOpportunity: '',
	},
	orderSummary: {
		title: 'Order summary',
		subtotal: 'Subtotal',
		discount: 'Discount',
		shipping: 'Shipping',
		vat: 'VAT',
		totalPrice: 'Total price (incl. VAT)',
	},
	order: {
		customerInfoTitle: 'My information',
		shippingAddressTitle: 'Shipping address',
		billingAddressTitle: 'Billing address',
		shippingTitle: 'Shipping',
		paymentTitle: 'Payment',
		orderSummaryTitle: 'My order summary',
		comment: 'Comment',
		nameRequired: 'Name is required',
		addressRequired: 'Address is required',
		cityRequired: 'City is required',
		zipCodeRequired: 'Zip code is required',
		emailRequired: 'Email address is required',
		emailInvalid: 'Email address is invalid',
		phoneNumberRequired: 'Phone number is required',
		commentTooLong: 'Comment is too long (max 500 characters)',
		createOrderFailed: 'Creating the order and reserving the requested items failed.',
		basketMissing: 'Basket is empty or not found.',
		validationError: 'Error in form. Check your data.',
		missingStock: 'Not all product are in stock.',
		billingAddressRequired: 'Billing address is required',
		pageMetaData: {
			title: 'Order',
			description: 'Order',
			keywords: 'order',
		},
		customerReferenceRequired: '',
		deliveryMethodRequired: '',
		deliveryTermsRequired: '',
		desiredDeliveryDateRequired: '',
		legalEntityRequired: '',
		stockRequired: '',
	},
	orderConfirmation: {
		backButton: 'Continue shopping',
		heading: 'Thank you for your order',
		text: 'Your products will be packed and shipped as soon as possible.',
		orderNr: 'Order Nr.',
		headingAuthNeeded: 'Thank you for your order',
		textAuthNeeded: 'To see your order, you need to confirm your identity by entering your phone number.',
		submitAuthNeeded: 'Get order',
		phoneNrDoesNotMatch:
			'Phone number does not match the order number. If you have an account, try logging in to see your order.',
		orderMissing: 'Order cannot be found or expired.',
	},
	appBuilderSolution: {
		title: 'Technical product guid',
		description: 'Technical product guid',
		progressSegment: '1. Segment',
		segment: 'Segment',
		progressApplication: '2. Application',
		application: 'Application',
		progressSpecifications: '3. Specifications',
		specifications: 'Application Specifications',
		progressFilterUnit: '4. Filter unit',
		filterUnit: 'Filter unit',
		progressConfiguration: '5. configuration',
		configuration: 'configuration',
		progressService: '6. service',
		service: 'service',
		serviceMessage: '',
		progressSummary: '7. summary',
		summary: 'summary',
		metaDataDescription: {
			segment: 'Segment',
			application: 'Application',
			applicationSpecifications: 'Application Specifications',
			filterUnit: 'Filter unit',
			configuration: 'configuration',
			service: 'service',
			summary: 'summary',
		},
		services: {
			conditionsMonitoring: '',
			installation: '',
			maintenance: '',
			oilFuelAnalysis: '',
			projectBasedServices: '',
			rental: '',
		},
		progressSubApplication: '',
		subApplication: '',
		progressAdditional: '',
		noSecondary: 'No secondary',
		option: 'Option',
		primary: 'Primary',
		secondary: 'Secondary',
	},
	customers: {
		title: '',
		accountNo: 'Account No.',
		accountName: 'Account Name',
		owner: 'Owner',
		headerLinkLabel: 'Filter locator',
		filters: {
			applications: 'applications',
			customerCountry: 'Country',
			fluidtype: 'Fluid Type',
			industry: 'Industry',
			marineoffshore: 'Marine Offshore',
			mining: 'Mining',
			power: 'Power',
			customerSegment: 'Segment',
			wind: 'Wind',
			customerCity: 'City',
			customerGroup: 'Group',
			customerOwner: 'Owner',
			customerSubSegment: 'Subsegment',
			customerType: 'Type',
			applicationBrand: '',
			applicationFluidType: '',
			applicationModel: '',
			applicationType: '',
			customerKeyAccountManager: '',
		},
		map: {
			mapErrorMessage: 'Error loading map',
		},
		pageMetaData: {
			title: '',
			description: '',
		},
		customerGroup: '',
		customerNumber: '',
		customerSegment: '',
		customerSubSegment: '',
		customerType: '',
		groupCoName: '',
		internalName: '',
		keyAccountManager: '',
		nameLine2: '',
		pageNumberOutOfRange: '',
		pageSizeOutOfRange: '',
	},
	filterGroup: {
		accountInformation: '',
		application: '',
		installedEquipment: '',
	},
	registrationComposites: {
		registrationCompositeDoesNotExist: '',
		registrationCompositeLocationExists: '',
		targetRegistrationCompositeRequired: '',
		sourceRegistrationCompositeHasNoLocation: '',
		targetAccountRequired: '',
		targetAccountDoesNotExist: '',
		registrationCompositeAlreadyOnAccount: '',
	},
	locations: {
		address: 'address',
		description: 'description',
		editLocation: 'Edit Location',
		id: 'id',
		identifier: 'identifier',
		number: 'number',
		register: 'Register Location',
		latitude: 'latitude',
		longitude: 'longitude',
		locationName: 'Name of the site or vessel',
		site: 'site',
		type: 'Location type',
		vessel: 'vessel',
		saveSuccess: ' Location saved successfully',
		locationDetails: 'Location Details',
		identifierLengthExceeded: 'Identifier is too long',
		longitudeRequired: 'Longitude is required',
		longitudeLengthExceeded: 'Longitude is too long',
		latitudeRequired: 'Latitude is required',
		latitudeLengthExceeded: 'Latitude is too long',
		locationWithIdentifierExists: 'There is already a location with the same identifier',
		applications: 'Applications',
		filterUnits: 'Filter Units',
		link: 'Link to MarineTraffic',
		title: 'Locations',
		iMOnumber: 'IMO Number',
		pageMetaData: {
			title: '',
			description: '',
		},
		deleteHeadline: 'Are you sure you want to delete the location?',
		deleteMessage: 'Location saved successfully',
		deleteSuccess: 'Location deleted successfully along with its assets, filters units, and filter inserts.',
		operatorLengthExceeded: '',
		chartererLengthExceeded: '',
		operatorRequired: '',
		ownerLengthExceeded: '',
		ownerRequired: '',
		vesselType: '',
		vesselTypeLengthExceeded: '',
		vesselTypeRequired: '',
		ownerOperator: '',
		shipOwner: '',
		technicalManager: '',
		shipyard: '',
		charterer: '',
		notFound: '',
	},
	filterRegistrations: {
		filterUnitInApplicationAlreadyExists: 'A filter unit is already registered in the application',
		addFilterUnit: '',
		editFilterUnit: '',
		goToSelectionByApplication: '',
		articleNo: '',
		batchNo: '',
		dateOfSale: '',
		installationDate: '',
		filterInsertHeadline: '',
		quantity: '',
		lastChangedDate: '',
		save: '',
		edit: '',
		saveFailed: '',
		saveSuccess: '',
		name: '',
		delete: '',
		deleteFailed: '',
		deleteSuccess: '',
		defaultFilterInsertName: '',
		defaultUnitName: '',
		deleteFilterRegistrations: {
			headline: '',
			teaser: '',
			failed: '',
			success: '',
		},
		filterId: '',
		insertType: '',
		itemNumber: '',
		noItemFound: '',
		insertName: '',
		orderNo: '',
	},
	customer: {
		accountNo: '',
		name: '',
		owner: '',
		segment: '',
		subSegment: '',
		group: '',
		type: '',
		country: '',
		city: '',
		pageMetaData: {
			title: '',
			description: '',
		},
		groupCoName: '',
		keyAccountManager: '',
		status: '',
		thirdPartyResponsible: '',
		internalName: '',
		nameLine2: '',
	},
	applications: {
		powerSupply: 'Power Supply',
		applicationInformation: '',
		nameOfApplication: '',
		group: '',
		groupInfo: '',
		name: '',
		segment: '',
		application: '',
		brand: '',
		model: '',
		filterVolume: '',
		comments: '',
		editApplication: '',
		registerApplication: '',
		addComment: '',
		saveComment: '',
		saveCommentSuccess: '',
		saveCommentFailed: '',
		chooseOrAddGroup: '',
		goToSelectionByApp: '',
		filterUnitHeadline: '',
		sparePartHeadline: '',
		deleteFailed: '',
		deleteSuccess: '',
		seeDetails: '',
		applicationListHeadline: '',
		deleteApplicationRegistrations: {
			headline: '',
			teaser: '',
			failed: '',
			success: '',
		},
		switchCustomer: {
			headline: '',
			teaser: '',
			failed: '',
			yesContinueBtn: '',
		},
		pageMetaData: {
			title: '',
			description: '',
		},
		title: '',
		diesel: 'Diesel',
		fluidType: 'Fluid Type',
		oil: 'Oil',
		other: 'Other',
		additionalInformation: '',
		ambientTemperature: '',
		operationTemperature: '',
		systemVolume: '',
		viscosity: '',
		fluidBrand: '',
		maxAmbientTemperature: '',
		maxOperationTemperature: '',
		minAmbientTemperature: '',
		minOperationTemperature: '',
		normalOperationTemperature: '',
		max: '',
		min: '',
		normal: '',
		temperatureUnit: '',
		viscosityUnit: '',
		volumeUnit: '',
		maxError: '',
		minError: '',
		normError: '',
		oilSystem: '',
		oilSystemBrand: '',
		registerComposite: '',
	},
	applicationRegistrations: {
		chooseSegment: '',
		chooseApplication: '',
		chooseSegmentFirst: '',
		save: '',
		saveFailed: '',
		saveSuccess: '',
	},
	sparePartRegistrations: {
		addSparePart: '',
		editSparePart: '',
		articleNo: '',
		quantity: '',
		description: '',
		saleDate: '',
		defaultDescription: '',
		save: '',
		saveFailed: '',
		saveSuccess: '',
		deleteSparePart: {
			headline: '',
			teaser: '',
			failed: '',
		},
	},
	applicationSummary: {
		segment: '',
		application: '',
		filterSpecification: '',
		segmentSpecification: '',
		filterInserts: '',
		addon: '',
		addToOffer: '',
		addedToOfferError: '',
		addedToOfferSuccess: '',
		filterUnit: '',
		contactPerson: '',
		mobile: '',
		includedInPrice: '',
		subApplication: '',
		additionals: '',
		segmentSpecifications: '',
		unitConfiguration: '',
		backToSelector: '',
	},
	offer: {
		editOffer: '',
		deleteOffer: '',
		downloadOffer: '',
		historyHeadline: '',
		name: '',
		offerNo: '',
		offerDate: '',
		status: '',
		offerStatus: {
			approved: '',
			awaitingApproval: '',
			draft: '',
		},
		overwriteBasket: {
			headline: '',
			teaser: '',
		},
		deleteOfferModal: {
			headline: '',
			teaser: '',
			failed: '',
		},
	},
	opportunities: {
		opportunityID: 'Opportunity ID',
		selectOpportunity: 'Select an opportunity',
		confirmation: {
			headline: '',
			text: '',
		},
		saveFailed: '',
	},
	opportunity: {
		contactPerson: '',
		customerReference: '',
		date: '',
		deliveryAddress: '',
		deliveryMethod: '',
		desiredDelivery: '',
		incoTerms: '',
		internalContact: '',
		ourSalesPerson: '',
		paymentTerms: '',
		quotationExpirationDate: '',
		quoteType: '',
		salesAndDeliveryTerms: '',
		legalEntity: '',
		city: '',
		zipcode: '',
		stock: '',
	},
	composite: {
		deleteComposite: {
			headline: '',
			teaser: '',
			failed: '',
			success: '',
			button: '',
		},
		moveComposite: {
			button: 'Move',
			headline: 'Move',
			teaser: 'Choose whether to move the filter unit, optionally together with its location, to another application, or the whole registration to another account.',
			moveFilterUnitOption: 'Move filter unit to another application',
			moveFilterUnitWithLocationOption: 'Move filter unit and location to another application',
			moveCompositeOption: 'Move the whole registration to another account',
			confirmButton: 'Confirm move',
			selectApplication: 'Select an application',
			noApplicationsAvailable: 'There are no applications without a filter unit on this account.',
			noApplicationsWithoutLocationAvailable:
				'There are no applications without a filter unit and without a location on this account.',
			filterUnitMoved: 'The filter unit was moved',
			filterUnitMoveFailed: 'Moving the filter unit failed',
			filterUnitAndLocationMoved: 'The filter unit and location were moved',
			filterUnitAndLocationMoveFailed: 'Moving the filter unit and location failed',
			compositeMoved: 'The registration was moved',
			compositeMoveFailed: 'Moving the registration failed',
			searchAccounts: 'Search accounts',
			noAccountsFound: 'No accounts found',
		},
	},
	powerBiReport: {
		tryAgain: '',
		loadError: '',
		loadingReport: '',
		noAccessError: '',
		sessionExpiredError: '',
		signInAgain: '',
	},
};

export default translations;
